export default __webpack_public_path__ + "static/media/questionsets.eab9a3c7.svg";